import { render } from "./SendConfirmModal.vue?vue&type=template&id=0ccbccf2&scoped=true"
import script from "./SendConfirmModal.vue?vue&type=script&lang=js"
export * from "./SendConfirmModal.vue?vue&type=script&lang=js"

import "./SendConfirmModal.vue?vue&type=style&index=0&id=0ccbccf2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1189531127/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ccbccf2"]])

export default __exports__